module.exports = __webpack_public_path__ + "img/birka.ad003f98.png";